export type RegistrationNotice = {
  studentId: string;
  eventId: string;
  eventName: string;
  dateLabel: string;
  timeLabel: string;
  location: string;
  status: "registered" | "waitlisted";
  /** True when a cancellation moved this student off the waitlist into a seat. */
  promoted?: boolean;
};

type Listener = (notice: RegistrationNotice) => void;

let listener: Listener | null = null;

export function setRegistrationNoticeListener(next: Listener | null): void {
  listener = next;
}

export function emitRegistrationNotice(notice: RegistrationNotice): void {
  listener?.(notice);
}
